import { combineReducers } from 'redux';
import { WidgetType } from 'widgets/WidgetType';
import { OpenSubmissionsCapsuleWidgetState } from 'widgets/openSubmissions/capsule/store/OpenSubmissionsCapsuleWidgetState';
import { openSubmissionsStreamReducer } from 'widgets/openSubmissions/store/stream/reducer';
import { OpenSubmissionsActionPayload } from 'widgets/openSubmissions/store/actions';
import { createWidgetsReducer } from 'widgets/store/widgetsReducerFactory';

const widgetStateReducer = combineReducers<OpenSubmissionsCapsuleWidgetState>({
    stream: openSubmissionsStreamReducer,
});

export const openSubmissionsCapsuleWidgetsReducer = createWidgetsReducer<
    OpenSubmissionsCapsuleWidgetState,
    OpenSubmissionsActionPayload
>(WidgetType.OPEN_SUBMISSIONS_CAPSULE, widgetStateReducer);
